// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={55}
    height={69}
    viewBox="0 0 55 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8466 5.54599C15.6938 5.54599 13.9486 7.29118 13.9486 9.44398V24.5052C13.9486 25.8296 12.875 26.9032 11.5506 26.9032C10.2262 26.9032 9.15259 25.8296 9.15259 24.5052V9.44398C9.15259 4.64243 13.045 0.75 17.8466 0.75H34.3411C39.1426 0.75 43.035 4.64243 43.035 9.44399V14.742C43.035 16.0664 41.9614 17.14 40.6371 17.14C39.3127 17.14 38.2391 16.0664 38.2391 14.742V9.44399C38.2391 7.29118 36.4939 5.54599 34.3411 5.54599H17.8466Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.0147 42.9675C51.0147 36.3364 48.38 29.9769 43.6902 25.288C39.0004 20.5992 32.6397 17.965 26.0073 17.965C19.375 17.965 13.0143 20.5992 8.32446 25.288C3.63467 29.9769 1 36.3364 1 42.9675C1 46.2509 1.64681 49.5021 2.90355 52.5356C4.16029 55.569 6.00232 58.3253 8.32446 60.647C13.0143 65.3359 19.375 67.97 26.0073 67.97C32.6396 67.9696 39 65.3352 43.6897 60.6464C48.3794 55.9577 51.0142 49.5984 51.0147 42.9675Z"
      fill="#0078EF"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M45.1109 42.9673C45.1109 37.9017 43.0982 33.0436 39.5156 29.4617C35.933 25.8797 31.0739 23.8674 26.0073 23.8674C20.9408 23.8674 16.0817 25.8797 12.4991 29.4617C8.91648 33.0436 6.90381 37.9017 6.90381 42.9673C6.90381 45.4755 7.39792 47.9592 8.35796 50.2765C9.318 52.5938 10.7252 54.6993 12.4991 56.4729C16.0817 60.0549 20.9408 62.0672 26.0073 62.0672C31.0738 62.0668 35.9326 60.0544 39.5152 56.4725C43.0977 52.8907 45.1105 48.0328 45.1109 42.9673Z"
      fill="#ABE3FF"
    />
    <path
      d="M37.2633 42.9679C37.2633 39.9832 36.0774 37.1208 33.9665 35.0103C31.8556 32.8998 28.9926 31.7142 26.0074 31.7142C23.0221 31.7142 20.1591 32.8998 18.0482 35.0103C15.9373 37.1208 14.7515 39.9832 14.7515 42.9679C14.7515 44.4458 15.0426 45.9092 15.6083 47.2745C16.1739 48.6399 17.003 49.8805 18.0482 50.9255C20.1591 53.036 23.0221 54.2216 26.0074 54.2216C28.9925 54.2214 31.8554 53.0357 33.9663 50.9253C36.0771 48.8148 37.2631 45.9525 37.2633 42.9679Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M26.006 23.8674V27.0507"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M45.1075 42.9676H41.9229"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M26.006 62.0673V58.8826"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M6.90381 42.9676H10.0884"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M39.5134 29.4611L37.2633 31.7126"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M12.4966 56.4727L14.7467 54.2213"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M12.4966 29.4611L14.7467 31.7126"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M39.5134 56.4727L37.2633 54.2213"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <line
      x1={46.9668}
      y1={19.3054}
      x2={49.0719}
      y2={14.2321}
      stroke="#29292F"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <line
      x1={0.75}
      y1={-0.75}
      x2={6.24273}
      y2={-0.75}
      transform="matrix(0.923639 0.383262 0.383262 -0.923639 48.1987 22.2846)"
      stroke="#29292F"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <line
      x1={48.2849}
      y1={20.5306}
      x2={53.3609}
      y2={18.4318}
      stroke="#29292F"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
const SvgUnlock = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgUnlock;
